import { useEffect, useState } from 'react'
import { VStack, Box, Text } from '@chakra-ui/react'
import { useReadBook } from '@!/Hooks'
import { PrimaryButton } from '@!/components/Button'
import { ConfirmPopupModal } from '@!/components/Modal'

export const ReadFreeButton = ({ title }) => {
  const [readFreeContentMutation, redirectUrl, apiError, setApiError] = useReadBook('free')
  const [popupText, setPopupText] = useState('')
  const [confirmModalOpen, setConfirmModalOpen] = useState(false)

  useEffect(() => {
    if (!redirectUrl) return

    window.location.href = redirectUrl
  }, [redirectUrl])

  const handleReadFreeContent = () => {
    const popText = `「${title.title_name}」は${title.first_content_publish_end_date}まで無料で閲覧できます。`
    setPopupText(popText)
    setConfirmModalOpen(true)
  }

  const execReadBook = () => {
    setConfirmModalOpen(false)
    readFreeContentMutation.mutate({ contentId: title.first_content_id })
  }

  const handleApiError = () => {
    setApiError(null)
  }

  return (
    <PrimaryButton variant="outline" w="128px" height="37px" onClick={() => handleReadFreeContent()}>
      <VStack spacing={0}>
        <Text>無料で読む</Text>
        {title.first_content_publish_end_date && <Box fontSize="3xs">{`${title.first_content_publish_end_date}まで`}</Box>}
      </VStack>
      <ConfirmPopupModal handlePopup={() => execReadBook()} text={popupText} isOpen={confirmModalOpen} />
      <ConfirmPopupModal handlePopup={() => handleApiError()} text="エラーが発生しました。" isOpen={!!apiError} />
    </PrimaryButton>
  )
}
